"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _types = require("./types");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SankeyLinkEditionPropTypes = {
  data: _propTypes.default.shape(_types.SankeyDataPropTypes).isRequired,
  set_data: _propTypes.default.func.isRequired,
  selected_link: _propTypes.default.shape(_types.SankeyLinkPropTypes).isRequired,
  show: _propTypes.default.bool.isRequired,
  getValueIndex: _propTypes.default.func.isRequired
};

var SankeyLinkEdition = function SankeyLinkEdition(_ref) {
  var data = _ref.data,
      set_data = _ref.set_data,
      selected_link = _ref.selected_link,
      getValueIndex = _ref.getValueIndex,
      children = _ref.children;
  var tags_catalog = data.tags_catalog;
  var tags_visible = Object.keys(tags_catalog).length > 0;

  var _useState = (0, _react.useState)(tags_visible ? Object.keys(tags_catalog)[0] : ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tags_group_key = _useState2[0],
      set_tags_group_key = _useState2[1];

  var value_index = getValueIndex(data);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    defaultActiveKey: "flux_data",
    id: "settings-layout"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "flux_data",
    title: "Donn\xE9es"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Affichage")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    value: selected_link.display_value[value_index],
    onChange: function onChange(evt) {
      selected_link.display_value[value_index] = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "flux_attributes",
    title: "Apparence"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Couleur:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "color",
    value: selected_link.color,
    onChange: function onChange(evt) {
      selected_link.color = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Position du centre")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: "1",
    step: "0.05",
    value: (selected_link.left_horiz_shift + selected_link.right_horiz_shift) / 2,
    onChange: function onChange(evt) {
      selected_link.left_horiz_shift = +evt.target.value - selected_link.shift_gap;
      selected_link.right_horiz_shift = +evt.target.value + selected_link.shift_gap;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 2
  }, (selected_link.left_horiz_shift + selected_link.right_horiz_shift) / 2)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Ecart entre Poign\xE9es")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: "0.5",
    step: "0.05",
    value: selected_link.shift_gap,
    onChange: function onChange(evt) {
      selected_link.shift_gap = +evt.target.value;
      var center = (selected_link.left_horiz_shift + selected_link.right_horiz_shift) / 2;
      selected_link.left_horiz_shift = center - selected_link.shift_gap;
      selected_link.right_horiz_shift = center + selected_link.shift_gap;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 2
  }, selected_link.shift_gap)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Type:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Courbe",
    checked: selected_link.curved,
    onChange: function onChange(evt) {
      selected_link.curved = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Fl\xEAche",
    checked: selected_link.arrow,
    onChange: function onChange(evt) {
      selected_link.arrow = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Recyclage",
    checked: selected_link.recycling ? selected_link.recycling : undefined,
    onChange: function onChange(evt) {
      selected_link.recycling = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Courbure")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Range, {
    min: "0",
    max: "1",
    step: "0.1",
    value: selected_link.curvature,
    disabled: !selected_link.curved,
    onChange: function onChange(evt) {
      selected_link.curvature = +evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 2
  }, selected_link.curvature)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    inline: true,
    name: "orientation",
    type: "radio",
    label: "Horiz-Horiz",
    value: "hh",
    checked: selected_link.orientation === 'hh',
    onChange: function onChange(evt) {
      selected_link.orientation = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    inline: true,
    name: "orientation",
    type: "radio",
    label: "Vert-Vert",
    value: "vv",
    checked: selected_link.orientation === 'vv',
    onChange: function onChange(evt) {
      selected_link.orientation = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    inline: true,
    name: "orientation",
    type: "radio",
    label: "Vert-Horiz",
    value: "vh",
    checked: selected_link.orientation === 'vh',
    onChange: function onChange(evt) {
      selected_link.orientation = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    inline: true,
    name: "orientation",
    type: "radio",
    label: "Horiz-Vert",
    value: "hv",
    checked: selected_link.orientation === 'hv',
    onChange: function onChange(evt) {
      selected_link.orientation = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "label",
    title: "Label"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "black",
    type: "radio",
    label: "Label en noir",
    checked: selected_link.text_color === 'black',
    onChange: function onChange() {
      selected_link.text_color = 'black';
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "white",
    type: "radio",
    label: "Label blanc",
    checked: selected_link.text_color === 'white',
    onChange: function onChange() {
      selected_link.text_color = 'white';
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "same_color",
    type: "radio",
    label: "Label en couleur",
    checked: selected_link.text_color === selected_link.color,
    onChange: function onChange() {
      selected_link.text_color = selected_link.color;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Label visible",
    checked: selected_link.label_visible,
    onChange: function onChange(evt) {
      selected_link.label_visible = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Position laterale:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    value: "beginning",
    type: "radio",
    label: "D\xE9but",
    checked: selected_link.label_position === 'beginning',
    onChange: function onChange(evt) {
      selected_link.label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    value: "middle",
    type: "radio",
    label: "Milieu",
    checked: selected_link.label_position === 'middle',
    onChange: function onChange(evt) {
      selected_link.label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    value: "end",
    type: "radio",
    label: "Fin",
    checked: selected_link.label_position === 'end',
    onChange: function onChange(evt) {
      selected_link.label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    value: "frozen",
    type: "radio",
    label: "Fig\xE9",
    checked: selected_link.label_position === 'frozen',
    onChange: function onChange(evt) {
      selected_link.label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
    type: "checkbox",
    label: "Attach\xE9 au flux",
    disabled: selected_link.label_position === 'frozen',
    checked: selected_link.label_on_path && selected_link.label_position !== 'frozen',
    onChange: function onChange(evt) {
      selected_link.label_on_path = evt.target.checked;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Position orthogonale:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    value: "below",
    type: "radio",
    label: "Dessous",
    checked: selected_link.orthogonal_label_position === 'below',
    onChange: function onChange(evt) {
      selected_link.orthogonal_label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    value: "middle",
    type: "radio",
    label: "Milieu",
    checked: selected_link.orthogonal_label_position === 'middle',
    onChange: function onChange(evt) {
      selected_link.orthogonal_label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    value: "above",
    type: "radio",
    label: "Dessus",
    checked: selected_link.orthogonal_label_position === 'above',
    onChange: function onChange(evt) {
      selected_link.orthogonal_label_position = evt.target.value;
      set_data((0, _objectSpread2.default)({}, data));
    }
  })))), Object.keys(tags_catalog).length ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "tags",
    title: "Tags"
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, "Tag Groupe:")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    onChange: function onChange(evt) {
      return set_tags_group_key(evt.target.value);
    }
  }, Object.entries(tags_catalog).map(function (tags_group, i) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: i,
      value: tags_group[0],
      selected: tags_group_key === tags_group[0]
    }, tags_group[1].group_name);
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    as: _reactBootstrap.Row
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, {
    striped: true,
    bordered: true,
    hover: true
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Nom"), /*#__PURE__*/_react.default.createElement("th", null, "Appartenance"))), /*#__PURE__*/_react.default.createElement("tbody", null, tags_visible && tags_group_key != '' ? Object.entries(tags_catalog[tags_group_key].tags).map(function (tags) {
    var link_tags = selected_link.tags[tags_group_key];
    var checked = link_tags ? link_tags.includes(tags[0]) : true;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: tags[0]
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, null, tags[1].name)), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormCheck, {
      name: 'element_visible' + tags[0],
      checked: checked,
      id: tags[0],
      type: "checkbox",
      onChange: function onChange(evt) {
        var new_nb_element = evt.target;
        var tag_key = new_nb_element.id;
        var visible = new_nb_element.checked;

        if (visible) {
          if (!selected_link.tags[tags_group_key]) {
            selected_link.tags[tags_group_key] = [];
          }

          selected_link.tags[tags_group_key].push(tag_key);
        } else {
          selected_link.tags[tags_group_key].splice(selected_link.tags[tags_group_key].indexOf(tag_key));
        }

        set_data((0, _objectSpread2.default)({}, data));
      }
    })));
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null))))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "flux_tooltip",
    title: "Tooltip"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormLabel, {
    column: true,
    sm: 1
  }, "Tooltip:"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 11
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    as: "textarea",
    rows: 10,
    value: selected_link.tooltip_text ? selected_link.tooltip_text : '',
    onChange: function onChange(evt) {
      selected_link.tooltip_text = evt.target.value.split('\n').join('\\n');
      set_data((0, _objectSpread2.default)({}, data));
    }
  }))))), children)));
};

var _default = SankeyLinkEdition;
exports.default = _default;